
export default {
 name: "TikTok",
 props: {
    id: {
      default: '',
      type: String,
    },
    videoId: {
      default: '7416313218450083104',
      type: String,
    },
    width: {
      default: '250',
      type: String,
    },
    height: {
      default: '444',
      type: String,
    },
    title: {
      default: 'TikTok Video',
      type: String,
    },
 },
 data() {
    return {
      isVisible:false,
      embedHtml: null,
      schemaData: null
    }
  },
  // head() {
  //   if(this.structuredData){
  //     return {
  //       script: [{ type: 'application/ld+json', json: this.structuredData }]
  //     }
  //   }

  // },
  // computed: {
  //   structuredData() {
  //     if(this.schemaData) {
  //       const uploadDate = this.extractTimestamp(this.schemaData.thumbnail_url)
  //       return {
  //       "@context":"https://schema.org",
  //       "@type":"VideoObject",
  //       "name":this.schemaData.title,
  //       "thumbnailUrl":this.schemaData.thumbnail_url,
  //       "contentUrl":this.$props.videoUrl,
  //       "author":this.schemaData.author_name,
  //       "provider":this.schemaData.provider,
  //       uploadDate
  //     }
  //     } else {
  //       return null
  //     }

  //   }
  // },
  mounted() {
    // this.getEmbedCode()
    // Add a listener for messages from the iframe
    window.addEventListener('message', this.handleMessage);
  },
  beforeDestroy() {
    // Clean up the event listener
    window.removeEventListener('message', this.handleMessage);
  },
  methods:{
    handleMessage(event) {
      console.log('EVENT RECEIVED', event.data);

      // Ensure the message comes from the TikTok iframe
      if (event.origin.includes('tiktok.com') && event.data['x-tiktok-player']) {
        const { type, value } = event.data;

        // Check if the event's source matches this instance's iframe
        const iframe = this.$refs[this.videoId]; // Get the iframe using the videoId as the ref
        if (!iframe || event.source !== iframe.contentWindow) {
          return; // Ignore events from other iframes
        }

        // Detect when the video starts playing
        if (type === 'onStateChange' && value === 1) {
          console.log('Video started playing');
          this.trackPlay();
        }

        // Detect when the video stops playing
        if (type === 'onStateChange' && value === 2) {
          console.log('Video stopped playing');
          this.trackStop();
        }
      }
    },
    trackPlay() {
      console.log('Tracking video play:', this.$props.videoId, this.$route.path);
      this.$gtm.push({
        event: 'tiktok_video_play',
        video: this.$props.videoId,
        page: this.$route.path,
      });
    },
    trackStop() {
      console.log('Tracking video stop:', this.$props.videoId, this.$route.path);
      this.$gtm.push({
        event: 'tiktok_video_stop',
        video: this.$props.videoId,
        page: this.$route.path,
      });
    },
    visibilityChanged(isVisible, entry) {
      this.isVisible = isVisible
      console.log(isVisible, entry)
    },
//     async getEmbedCode() {
//       const result = await fetch(`https://www.tiktok.com/oembed?url=${this.$props.videoUrl}`)
//       const data = await result.json()
//       // this.embedHtml = data.html
//       this.schemaData = data
//     },
//     extractTimestamp(thumbnailUrl) {
//     // Use a regular expression to extract the part of the URL containing the timestamp
//     const match = thumbnailUrl.match(/_(\d+)\?/);
//     if (match && match[1]) {
//          // Convert the Unix timestamp to a number
//          const unixTimestamp = parseInt(match[1], 10);

//         // Create a Date object and convert it to ISO 8601 format
//         const iso8601Timestamp = new Date(unixTimestamp * 1000).toISOString();
//         return iso8601Timestamp;
//     }
//     return null; // Return null if no timestamp is found
// }

  }
}
